<template>
  <div class="footer">
    <div class="container">
      <div class="row">
        <div class="col-xs-12" style="text-align: right">
          <a href="http://dicta.org.il/aboutus-en.html" target="_blank" class="f black link">About Dicta</a>
          <span>&nbsp;</span><span>&nbsp;</span>
          <a href="/static/help/Content/Tiberias/about.htm" target="_blank" class="f black link">About Tiberias</a>
          <span>&nbsp;</span><span>&nbsp;</span>
          <a href="/static/help/Default.htm" target="_blank" class="f black link">Documentation</a>
          <span>&nbsp;</span><span>&nbsp;</span>
          <a href="http://dicta.org.il/tos.html" target="_blank"  class="f black link">Terms of Service</a>
          <span>&nbsp;</span><span>&nbsp;</span>
          <a href="#" data-toggle="modal" data-target="#contactus" data-backdrop="false" class="f black link">Contact us</a>
          <span>&nbsp;</span><span>&nbsp;</span>
          <a href="https://www.facebook.com/dictatools/" target="_blank">
            <i class="fab fa-facebook-f mx-2 facebook"></i>
          </a>
          <span>&nbsp;</span><span>&nbsp;</span>
           <a href="https://www.youtube.com/watch?v=yUx7VD6YHpw&feature=youtu.be" target="_blank">
            <i class="fab fa-youtube mx-2"></i>
          </a>
        </div>
      </div>
    </div>
    <contactUs></contactUs>
  </div>
</template>

<script>
import contactUs from './contactUs.vue'
export default {
  name: 'AppFooter',
  components: {contactUs},
  data () {
    return {
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/appFooter.vue